import React, { Component } from "react";
import { observer } from "mobx-react";

import { IAnalyticsModuleParameters } from "@formant/core/model/IAnalyticsModuleParameters";

import { AnalyticsChart } from "../../AnalyticsChart";
import { StreamIcon } from "../../common/StreamIcon";
import { IBaseModuleProps } from "../IBaseModuleProps";
import { Module } from "../Module";

interface IAnalyticsModuleProps extends IBaseModuleProps {
    moduleConfigurationId?: string;
}

@observer
export class AnalyticsModule extends Component<IAnalyticsModuleProps> {
    render() {
        const params = this.props.layoutModule?.configuration
            ?.parameters as IAnalyticsModuleParameters;
        if (params === undefined || !params?.AnalyticsModuleDefinitionId) {
            return false;
        }

        return (
            <Module
                {...this.props}
                noGrid={false}
                type={this.props.streamType}
                displayName={params?.AnalyticsModuleName}
                icon={<StreamIcon type="numeric set" />}
                editingLayout={false}
            >
                <AnalyticsChart {...this.props} params={params} />
            </Module>
        );
    }
}
